/**
=========================================================
* Arakan - v2.1.0
=========================================================

* Product Page: https://www.trakib.com/product/material-dashboard-pro-react
* Copyright 2022 Trakib (https://www.trakib.com)

Coded by www.trakib.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// @material-ui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Arakan components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";

// Settings page components
import FormField from "components/FormField";

import { IconButton, InputLabel } from "@mui/material";

// Import from Material-UI icons
import AttachFileIcon from "@mui/icons-material/AttachFile";
// or
import MDInput from "components/MDInput";
import LangSwitcher from "components/LangSwitcher";
import MDEditor from "components/MDEditor";

function LangForm({
  project,
  id,
  info,
  setInfo,
  changeHandler,
  notification,
  setNotification,
  errors,
  setErrors,
}) {
  const [selectedLang, setSelectedLang] = useState();
  const [oldSelectedLang, setOldSelectedLang] = useState();
  // const [info, setInfo] = useState({
  //   translations: {},
  // });
  // const [infoHis, setInfoHis] = useState({});

  // get data from infoHis when change language selection from lang switcher

  useEffect(() => {
    if (!project.id || !selectedLang) return;

    let newData = {};
    if (oldSelectedLang.code !== selectedLang.code) {
      newData = info.translations;
      newData[oldSelectedLang.code] = {
        ...info.translations[oldSelectedLang.code],
        languages_code: oldSelectedLang.code,
      };
    }

    if (oldSelectedLang.code === selectedLang.code)
      setInfo({
        translations: project.translations,
      });
    else
      setInfo({
        translations: newData,
      });
  }, [project, selectedLang]);

  useEffect(() => {
    if (!selectedLang?.code) return;

    setInfo((prev) => {
      // Clone translations
      const translations = { ...(prev.translations || {}) };

      // If this language doesn’t exist, initialize it
      if (!translations[selectedLang.code]) {
        translations[selectedLang.code] = {
          name: "",
          languages_code: selectedLang.code,
        };
      }

      return { ...prev, translations };
    });
  }, [selectedLang]);

  useEffect(() => {
    if (notification.value === true) {
      setTimeout(() => {
        setNotification({ value: false, color: "info", message: "" });
      }, 5000);
    }
  }, [notification]);

  const safeHistory = info?.translations?.[selectedLang?.code] || {};

  return (
    <>
      <Card sx={{ overflow: "visible", p: 5 }}>
        <MDBox p={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <LangSwitcher
                setSelectedLang={setSelectedLang}
                setOldSelectedLang={setOldSelectedLang}
                stickyNavbar={false}
              />
            </Grid>
            {/* {info.translations[selectedLang?.code] && ( */}
            <Grid item xs={12} lg={12}>
              <FormField
                onChange={(e) => changeHandler(e, selectedLang.code)}
                label="الاسم"
                name="name"
                value={safeHistory?.name ?? ""}
                error={errors[`name-${selectedLang?.code}`]}
              />
            </Grid>
            <Grid item xs={12} lg={12}>
              <FormField
                onChange={(e) => changeHandler(e, selectedLang.code)}
                label="الرابط"
                name="link"
                value={safeHistory?.link ?? ""}
                error={errors[`link-${selectedLang?.code}`]}
              />
            </Grid>
          </Grid>
        </MDBox>
      </Card>
      {/* {notification.value === true && (
        <MDAlert color={notification.color} mt="20px">
          <MDTypography variant="body2" color="white">
            {notification.message}
          </MDTypography>
        </MDAlert>
      )} */}
    </>
  );
}

export default LangForm;
